import { API_BASE_URL } from './api';

export interface PublicGroup {
  name: string;
  description?: string | null;
  memberCount: number;
}

export interface PublicEvent {
  title: string;
  startTime: string;
  endTime?: string | null;
  location?: string | null;
  goingCount: number;
  /** Only set when the hosting group/club is itself publicly listed. */
  hostedBy?: string | null;
}

/** What a signed-out visitor may see — everything here is opt-in by its owner. */
export interface PublicCommunity {
  groups: PublicGroup[];
  clubs: PublicGroup[];
  events: PublicEvent[];
}

export const publicService = {
  getCommunity: async (): Promise<PublicCommunity> => {
    const res = await fetch(`${API_BASE_URL}/public/community`);
    if (!res.ok) throw new Error('Failed to load community');
    return res.json();
  },
};
